// extracted by mini-css-extract-plugin
module.exports = {"itemText":"list__itemText--1MSFR","primary":"list__primary--2zz8p","list":"list__list--37F0c"};